module.exports = __webpack_public_path__ + "media/images/menu/m11-f63202ca6ea06784caabc71dc5045425.JPG";